<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="p-2">
        <template v-if="store.state.seminar.seminarDetails">
          <h1 class="text-title-underline">{{ store.state.seminar.seminarDetails.seminar_user ? `${seminarTitle}${t('seminar_details.title.confirm')}` : `${seminarTitle}${t('seminar_details.title.apply')}` }}</h1>
          <template v-if="store.state.seminar.seminarDetails.seminar_user">
            <div class="mb-4">
              <seminar-details-completed :seminarDetails="store.state.seminar.seminarDetails" />
            </div>
          </template>
          <div class="card-outlined p-4 mb-4">
            <seminar-details-body :seminarDetails="store.state.seminar.seminarDetails" />
          </div>
          <template v-if="!store.state.seminar.seminarDetails.seminar_user">
            <div>
              <seminar-details-apply :seminarDetails="store.state.seminar.seminarDetails" />
            </div>
          </template>
        </template>
        <template v-else>
          セミナー情報が見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, onBeforeUpdate, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import { SeminarAttributes } from '@/types/models/seminar'
import SeminarDetailsBody from '@/components/SeminarDetailsBody.vue'
import SeminarDetailsCompleted from '@/components/SeminarDetailsCompleted.vue'
import SeminarDetailsApply from '@/components/SeminarDetailsApply.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, SeminarDetailsBody, SeminarDetailsCompleted, SeminarDetailsApply, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const route = useRoute()
    const seminarTitle = computed(() => store.state.seminar.seminarDetails?.seminar_category_id === 3 ? '懇親会' : t('seminar_details.title.seminar'))

    const initialize = () => {
      axios
        .get<ApiResponse<SeminarAttributes>>(`/seminar/${route.params.seminar_id}`)
        .then(response => {
          store.commit('seminar/setSeminarDetails', response.data.payload)
        })
    }

    onBeforeUpdate(() => {
      initialize()
    })

    onMounted(() => {
      initialize()
    })

    return {
      t,
      store,
      seminarTitle
    }
  },
})
</script>
